// regex to detect 'quoted' or "quoted" strings....
const singleQuoteString = "'[^']*'";
const doubleQuoteString = '"[^"]*"';
const quoteString = `${singleQuoteString}|${doubleQuoteString}`;

// regex to detect {{ tokens }} or {% tokens %}
const displayToken = `{{([^}'"]|${quoteString})*}}`;
const logicToken = `{%([^%'"]|${quoteString})*%}`;
const liquidTokensRegex = new RegExp(`${displayToken}|${logicToken}`, 'ig');

/**
 * Tries to get all the liquid tokens in a given string.
 *
 * @param string
 * @returns {Array} Any/all matching tokens.  Empty array if there are none.
 *                  i.e. ["{{ contact.name }}", "{% if contact.name == 'bart' %}"]
 */
export const getLiquidTokens = (string) => string.match(liquidTokensRegex) || [];

/**
 * Gets all the liquid objects referenced in a given string.
 *
 * i.e. liquidObjectsUsed("Hello {{contact.first_name}} {{contact.last_name}}") =>
 *        [
 *          {
 *            object: 'contact',
 *            property: 'first_name',
 *            usage: '{{ contact.first_name }}'
 *          },
 *          {
 *            object: 'contact',
 *            property: 'last_name',
 *            usage: '{{ contact.last_name }}'
 *          }
 *        ]
 *
 * @param string
 * @returns {Array} Array of objects that matched
 */
export const liquidObjectsUsed = (string) => {
  const tokensUsed = getLiquidTokens(string);
  let ret = [];

  tokensUsed.forEach(usage => {
    const objects = [...usage.matchAll(/(\w+)\.(\w+)/ig)];

    ret = [
      ...ret,
      ...objects.map(([_, object, property]) => ({object, property, usage}))
    ];
  });

  return [...new Set(ret)].filter(x=>x);
};